import React, { useState } from 'react';
import { Poppins, Spacer } from 'src/common';
import { ExpandedIndicator } from '../../ExpandedIndicator';
import { TimelineEvent } from 'src/api/types/dashboard';
import { NoAction } from 'src/pages/DashboardPage/Events';
import { parseEvents } from 'src/pages/DashboardPage/Events/util';
import { motion } from 'framer-motion';
import { getSectionOpenState, setSectionOpenState } from 'src/pages/DashboardPage/Filters/util';
import moment from 'moment';

interface SectionProps {
  title: string;
  ranges: TimelineEvent[];
  id: string;
  overdue?: boolean;
}

export const Section: React.FC<SectionProps> = ({ ranges, title, id, overdue }) => {
  const [isOpen, setIsOpen] = useState(!getSectionOpenState({ id, storageKey: 'upcoming_actions' }));

  return (
    <>
      <div
        className="upcoming__head"
        onClick={() => {
          setSectionOpenState({ id, isOpen, storageKey: 'upcoming_actions' });
          setIsOpen(!isOpen);
        }}
      >
        <Poppins px={14} weight={500} color="cflowerBlue">
          {title}
        </Poppins>
        <ExpandedIndicator isOpen={isOpen} />
      </div>
      <motion.div
        initial={false}
        animate={{ height: isOpen ? 'unset' : 0 }}
        className="upcoming__collapse"
        transition={{ type: 'tween' }}
      >
        <Spacer $px={4} />
        <div className="upcoming__item">
          {ranges.length ? (
            ranges.map((event, idx) => {
              const eventDate = moment(event.event_date).startOf('day');
              const today = moment().startOf('day');
              const isToday = eventDate.diff(today, 'days') === 0;

              return parseEvents({
                events: [event],
                shownDate: true,
                overdue,
                isToday,
              })?.[0];
            })
          ) : (
            <NoAction />
          )}
        </div>
        <Spacer $px={12} />
      </motion.div>
    </>
  );
};
